import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

export default class McpTestimonialsSlider extends HTMLElement {
    swiperEl;
    swiper;

    connectedCallback() {
        this.resolveElements();
        this.initSwiper();
    }

    initSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            modules: [Navigation],
            slidesPerView: 1.1,
            spaceBetween: 16,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
            navigation: {
                prevEl: this.prevEl,
                nextEl: this.nextEl,
                disabledClass: "is-disabled",
            },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    spaceBetween: 32,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
            },
        });
    }

    resolveElements() {
        this.swiperEl = this.querySelector(".swiper");
        this.prevEl = this.querySelector("[data-prev]");
        this.nextEl = this.querySelector("[data-next]");
    }
}
